import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { resetPassword } from "../../api/auth";
import { authAtom, findAccount } from "../../recoil/atoms";

export const useResetPassword = () => {
  const onError = ({
    response: {
      status,
      data: { code, message },
    },
  }) => {
    if (status === 400 && code === "INVALID_RESET_PASSWORD") {
      alert(message);
      window.location.href = "/find-account";
    }
  };
  const onSuccess = () => {
    window.location.href = "/";
  };
  return useMutation(resetPassword, {
    onError,
    onSuccess,
  });
};
